var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[(_vm.stepCount)?_c('steps',{attrs:{"step-count":_vm.stepCount,"current-step":_vm.currentStep}}):_vm._e(),_vm._v(" "),_c('weui-group',{attrs:{"title":_vm.title}},[_c('weui-cell',[_c('img',{attrs:{"src":"https://open.weixin.qq.com/qr/code?username=gh_256a4981d572"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d7e8e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/QRCode.vue
// module id = null
// module chunks = 